// extracted by mini-css-extract-plugin
export default {"arrow":"SliderArrow_arrow__uouta","arrow--left":"SliderArrow_arrow--left__+QPlK","arrow--right":"SliderArrow_arrow--right__D8HOg","active":"SliderArrow_active__Jmtvh"};